import { ReactNode } from 'react'
import { Tabs } from '../../atoms/tabs'

type TabLabelsListProps = {
  children: ReactNode
  className?: string
}

export const TabLabelsList = ({ children, className }: TabLabelsListProps) => (
  <Tabs.List
    variant="outline"
    className={`border-b border-neutral-200 p-0 ${className ?? ''}`}
  >
    {children}
  </Tabs.List>
)
